import { defineMessages } from 'react-intl';

/**
 * Regulatory labelling copy that travels with Evidence output. The statement is
 * SWR-30 in the medical-device file and is asserted verbatim by the e2e suite,
 * so its wording is a controlled string, not editorial copy.
 */
export const evidenceRegulatoryMessages = defineMessages({
  medicalKnowledgeStatement: {
    defaultMessage:
      'Medical knowledge only. Not for autonomous decision making. Check sources and use your clinical judgement.',
    id: '6q9Sc5NfOn',
    description:
      'Regulatory statement shown with every Evidence answer inside Work and under the Evidence-mode composer (SWR-30)',
  },
  instructionsForUse: {
    defaultMessage: 'Instructions for Use',
    id: 'ncDTVBtwIm',
    description:
      'Link to the Heidi Evidence Instructions For Use document, shown with an Evidence answer inside Work',
  },
});
